/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountMappingView,
  CalendarEventsResult,
  CalendarListResult,
  Email,
  EventChangeRequest,
  EventChangeResponse,
  EventCreateRequest,
  EventCreateResponse,
  ExternalCalendar,
  FreeBusyResults,
  MapString,
  TenantConfigView,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "external-calendar";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns array of busy intervals for given user ids
   *
   * @name FreeBusy
   * @request GET:/v1/tenant/{tenantId}/user-free-busy
   * @deprecated
   */
  freeBusy = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      FreeBusyResults,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-free-busy`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for freeBusy */
  freeBusyPathGetter = (
    tenantId: string,
    query: {
      /** @minItems 1 */
      userIds: string[];
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-free-busy`, query);

  /**
   * @description Returns array of calendar events for given user id
   *
   * @name CalendarEvents
   * @request GET:/v1/tenant/{tenantId}/user-calendar-events
   * @secure
   */
  calendarEvents = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
      showCanceled: boolean;
      /** @minLength 1 */
      pageToken?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CalendarEventsResult,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-calendar-events`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarEvents */
  calendarEventsPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @format date-time */
      startDatetime: string;
      /** @format date-time */
      endDatetime: string;
      showCanceled: boolean;
      /** @minLength 1 */
      pageToken?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-calendar-events`, query);

  /**
   * No description
   *
   * @name CreateCalendarEvent
   * @request POST:/v1/tenant/{tenantId}/user-calendar-events
   * @secure
   */
  createCalendarEvent = (tenantId: string, data: EventCreateRequest, params: RequestParams = {}) =>
    this.request<
      EventCreateResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-calendar-events`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createCalendarEvent */
  createCalendarEventPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-calendar-events`);

  /**
   * No description
   *
   * @name PatchCalendarEvents
   * @request PATCH:/v1/tenant/{tenantId}/user-calendar-events
   * @secure
   */
  patchCalendarEvents = (tenantId: string, data: EventChangeRequest, params: RequestParams = {}) =>
    this.request<
      EventChangeResponse,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-calendar-events`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for patchCalendarEvents */
  patchCalendarEventsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user-calendar-events`);

  /**
   * @description [Deprecated - use "calendar-integration-status" endpoint instead] Returns connected calendar email for given user id
   *
   * @name AccountMapping
   * @request GET:/v1/tenant/{tenantId}/account-mapping
   */
  accountMapping = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AccountMappingView,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/account-mapping`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for accountMapping */
  accountMappingPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/account-mapping`, query);

  /**
   * @description Returns array of calendars for given user id
   *
   * @name CalendarList
   * @request GET:/v1/tenant/{tenantId}/user-calendar-list
   * @secure
   */
  calendarList = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @minLength 1 */
      pageToken?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      CalendarListResult,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user-calendar-list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarList */
  calendarListPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** @minLength 1 */
      pageToken?: string;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/user-calendar-list`, query);

  /**
   * @description Returns connected calendar for given user id
   *
   * @name Calendar
   * @request GET:/v1/public/tenant/{tenantId}/calendar
   */
  calendar = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ExternalCalendar,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/calendar`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendar */
  calendarPathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v1/public/tenant/${tenantId}/calendar`, query);

  /**
   * @description Returns the tenant config
   *
   * @name TenantConfig
   * @request GET:/v1/tenant/{tenantId}/tenant-config
   * @secure
   */
  tenantConfig = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantConfigView,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tenant-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for tenantConfig */
  tenantConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/tenant-config`);

  /**
   * @description Sets the show event contents flag
   *
   * @name SetShowEventContents
   * @request POST:/v1/tenant/{tenantId}/tenant-config/set-show-event-contents
   * @secure
   */
  setShowEventContents = (tenantId: string, data: TenantConfigView, params: RequestParams = {}) =>
    this.request<
      void,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tenant-config/set-show-event-contents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setShowEventContents */
  setShowEventContentsPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/tenant-config/set-show-event-contents`);
}
